import { Box, Button, Stack, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { minContentH, SITE_MIN_MARGIN } from "../const";

export const ErrorPage: React.FC = () => (
  <>
    <PageHeader>Error 404: Page not found...</PageHeader>
    <Box w="100%" maxW="100%" minH={minContentH} px={SITE_MIN_MARGIN}>
      <Stack spacing={4} py={4} mx="auto" maxW="1400px" w="100%">
        <Text fontSize="42px">😵 Oops!</Text>
        <Text>The page you are looking for currently doesn't exist, has been changed or was removed.</Text>
        <Text>But don't panic, return to the homepage by clicking the button below.</Text>
        <Link to="/">
          <Button variant="blue" color="white" fontSize="20px" borderRadius="48px">
            Return to Homepage
          </Button>
        </Link>
      </Stack>
    </Box>
  </>
);
